import { render, staticRenderFns } from "./shippingTable.vue?vue&type=template&id=3fc478ef&lang=pug&"
import script from "./shippingTable.vue?vue&type=script&lang=js&"
export * from "./shippingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports